export function LockIcon() {
  return (
    <svg
      fill="none"
      height="12"
      viewBox="0 0 12 12"
      width="12"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.5 5V4C8.5 2.61929 7.38071 1.5 6 1.5C4.61929 1.5 3.5 2.61929 3.5 4V5M6 7.25V8.25M4.4 10.5H7.6C8.44008 10.5 8.86012 10.5 9.18099 10.3365C9.46323 10.1927 9.6927 9.96323 9.83651 9.68099C10 9.36012 10 8.94008 10 8.1V7.4C10 6.55992 10 6.13988 9.83651 5.81901C9.6927 5.53677 9.46323 5.3073 9.18099 5.16349C8.86012 5 8.44008 5 7.6 5H4.4C3.55992 5 3.13988 5 2.81901 5.16349C2.53677 5.3073 2.3073 5.53677 2.16349 5.81901C2 6.13988 2 6.55992 2 7.4V8.1C2 8.94008 2 9.36012 2.16349 9.68099C2.3073 9.96323 2.53677 10.1927 2.81901 10.3365C3.13988 10.5 3.55992 10.5 4.4 10.5Z"
        stroke="#344054"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
